var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardLayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98131 1H8.30364C9.02537 1 9.71755 1.28498 10.2279 1.79225C10.7382 2.29952 11.0249 2.98753 11.0249 3.70492V7.46205C11.0249 8.17944 10.7382 8.86745 10.2279 9.37472C9.71755 9.88199 9.02537 10.167 8.30364 10.167H3.98131C3.25958 10.167 2.5674 9.88199 2.05706 9.37472C1.54672 8.86745 1.26001 8.17944 1.26001 7.46205L1.26001 3.70492C1.26001 2.98753 1.54672 2.29952 2.05706 1.79225C2.5674 1.28498 3.25958 1 3.98131 1Z",
    stroke: "white",
    strokeWidth: 0.904366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.778H11.558",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLayoutIcon);
export default __webpack_public_path__ + "static/media/CardLayoutIcon.2812a9f4d7d5650ec01e58879c9163c1.svg";
export { ForwardRef as ReactComponent };